import { APP_BASE_HREF, CommonModule, DatePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientJsonpModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { ThemeService } from './theme.service';
import { AlertComponent } from './_directives/alert.component';
import { PanelTabComponent } from './_directives/panel-tabs';
import { AuthGuard, AdminTabGuard, AdminPortalTabGuard } from './_guards';
import { AppSharedModule } from './kuba/shared/appShared.module';
import { LoginModule } from './login/login.module';
import { appRoutes } from './app.routing';
import { ErrorPageComponent } from './shared/common/error-page/error-page.component';
import { NotFoundComponent } from './shared/common/not-found/not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { InitialServices } from './_services/initial.services';
import { KubaServices } from './kuba/kuba.services';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { getBaseLocation } from './shared/common/common-functions.util';
import { ParamAwareRouteReuseStrategy } from './shared/routing/param-aware-route-reuse.strategy';
import { EcplDocumentExplorerModule } from './shared/ecpl-document-explorer';
import { ForgetPasswordModule } from './forget-password/forget-password.module';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';
import { KubaModule } from './kuba/kuba.module';
import { Interceptor } from './shared/interceptor';
import { MonitoringService } from './shared/monitoring.service';
import { GlobalErrorHandler } from './shared/error-handler.service';
import { ErrorHandler } from '@angular/core';
import { SdsModule } from './kuba/safety-data-sheet/sds.module';
import { provideKubaPrimeNG } from './prime-theme';
import { provideKubaTranslations } from './translation.providers';
import { NotificationService } from './shared/services/notification.service';

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    NotFoundComponent,
    ErrorPageComponent,
    PanelTabComponent,
  ],
  exports: [PanelTabComponent, TranslatePipe, TranslateDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppSharedModule,
    ToastModule,
    // Feature routes sit under admin/:id, portal/:id and business/:id. Angular 22 changes the
    // default to 'always', which would hand the business id to child routes that read their
    // own 'id' (e.g. project/new would open in edit mode). Keep the Angular 21 behaviour.
    RouterModule.forRoot(appRoutes, { paramsInheritanceStrategy: 'emptyOnly' }),
    LoginModule,
    KubaModule,
    SdsModule,
    ForgetPasswordModule,
    EcplDocumentExplorerModule,
    TranslatePipe,
    TranslateDirective
  ],
  providers: [
    provideKubaTranslations(),
    provideKubaPrimeNG(),
    AuthGuard,
    AdminTabGuard,
    { provide: MessageService, useExisting: NotificationService },
    AdminPortalTabGuard,
    AlertService,
    AuthenticationService,
    InitialServices,
    KubaServices,
    DatePipe,
    MonitoringService,
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseLocation,
    },
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
    { provide: RouteReuseStrategy, useClass: ParamAwareRouteReuseStrategy },
    ConfirmationService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),]
})
export class AppModule {}
